"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function distributeWithBacktracking(aspects, count, notEnoughCallback) {
    if (aspects.length === 0) {
        if (count > 0) {
            return 'not-enough-question';
        }
        return [];
    }
    // recalculate the distribution of items by their weights
    let distribution = aspects.map(x => x.weight);
    let remainingSum = distribution.reduce((x, y) => x + y, 0);
    let remainingDistribution;
    if (remainingSum === 0) {
        remainingDistribution = Array(aspects.length).fill(1 / aspects.length);
    }
    else {
        remainingDistribution = distribution.map(x => x / remainingSum);
    }
    let requiredCount = Math.round(count * remainingDistribution[0]);
    let diff = aspects[0].count - requiredCount;
    if (diff < 0) {
        if (notEnoughCallback) {
            notEnoughCallback(aspects.length, diff);
        }
        // we have missing questions
        requiredCount += diff;
    }
    let remainingQuestion = count - requiredCount;
    if (aspects.length === 1) {
        if (remainingQuestion > 0) {
            // it was the last, we need to backtrack
            return 'not-enough-question';
        }
        return [requiredCount];
    }
    // process children
    do {
        const children = distributeWithBacktracking(aspects.slice(1), remainingQuestion, notEnoughCallback);
        if (children !== 'not-enough-question') {
            // continue remaining aspects
            return [requiredCount, ...children];
        }
        if (diff <= 0) {
            // we have no more usable
            return 'not-enough-question';
        }
        requiredCount++;
        diff--;
        remainingQuestion--;
    } while (diff >= 0);
    return 'not-enough-question';
}
exports.distributeWithBacktracking = distributeWithBacktracking;
//# sourceMappingURL=distribute-with-backtracking.js.map